<template>
  <div>
    <div class="dialog-body-wrap">
      <div>
        <div class="item-wrap">
          <label>身份名称:</label>
          <el-input
            v-model="addBody.title"
            placeholder="请输入身份名称"
            class="name_input"
          ></el-input>
        </div>
        <div class="item-wrap">
          <label>管理模块:</label>
          <el-tree
            :data="powerTree"
            show-checkbox
            :default-expand-all="false"
            node-key="id"
            ref="tree"
            :props="defaultProps"
          />
        </div>
      </div>
      <div class="btn-wrap">
        <el-button @click="onCancelClick">取消</el-button>
        <el-button
          type="primary"
          @click="onSaveClick"
        >确定</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import CommonDialog from "@/components/CommonDialog";
import {
  LimitsList,
  addLimitsUser,
  SetLimitsList,
  delLimitsUser,
  getIdentityDetail
} from "@/api/auth";
import { mapState } from "vuex";

export default {
  data() {
    return {
      powerTree: [],
      defaultProps: {
        children: "children",
        label: "menu_name"
      },
      addBody: {
        title: "",
        rules_url: [],
        store_uuid: [],
        rules: [],
        rules_name: [],
        oneId: [] //存放所有一级菜单id
      },
      parent_rules: [], //一、二级列表的权限id
      type: "add",
      detailInfo: {},
      seconde_rule: []
    };
  },
  components: {},
  async mounted() {},
  async activated() {
    await this.getLimitList();
    const { id } = this.$route.query;
    if (id) {
      this.type = "edit";
      this._getIdentityDetail(id);
    } else {
      this.type = "add";
      this.addBody = {
        title: "",
        rules_url: [],
        store_uuid: [],
        rules: [],
        rules_name: [],
        oneId: [] //存放所有一级菜单id
      };
      this.$refs.tree.setCheckedKeys([]);
    }
  },
  computed: {
    ...mapState(["hotelData"])
  },
  methods: {
    async _getIdentityDetail(id) {
      const { status, data } = await getIdentityDetail(id);
      if (status === 200) {
        this.detailInfo = data;
        this.setData(data);
      }
    },
    async getLimitList() {
      const { data, status } = await LimitsList();
      if (status !== 200) return;
      let copyData = JSON.parse(JSON.stringify(data));
      if (copyData.one.length) {
        copyData.one.forEach(one => {
          one.children = one.two;
          if (one.two.length) {
            this.parent_rules.push(one.id);
          }
          one.two.forEach(two => {
            two.children = two.three;
            //存放二级列表权限id
            if (two.three.length) {
              this.parent_rules.push(two.id);
            }
          });
        });
      }
      this.powerTree = copyData.one;
    },
    // onBrandChange(uuid) {
    //   //把选的酒店清空
    //   this.$set(this.addBody, 'hotel_uuid', '')
    //   this.getBrandHotelData(uuid);
    // },
    // getBrandHotelData(uuid) {
    //   // //获取对应品牌的酒店数据
    //   let brandHotel = [];
    //   this.hotelData.forEach( item => {
    //     if (item.brand_uuid === uuid) {
    //       brandHotel.push(item)
    //     }
    //   })
    //   this.brandHotel = brandHotel;
    // },
    setData(row) {
      //只有两级把一级权限去掉 如果有三级就把一级和二级 权限去掉。否则权限会处于全选状态
      //获取权限列表的时候做了处理 符合的才会放到parent_rules里
      let rules = row.rules.filter(item => {
        return !this.parent_rules.includes(item);
      });
      if (row.rules && row.rules.length) {
        this.$nextTick(() => {
          this.addBody = JSON.parse(JSON.stringify(row));
          this.$refs.tree.setCheckedKeys(rules);
        });
      }
    },
    onCancelClick() {
      this.$router.go(-1);
    },
    async onSaveClick() {
      const tree = this.$refs.tree.getCheckedNodes(true);
      const { title } = this.addBody;
      if (!title) {
        this.$message("请输入身份名称");
        return;
      }
      if (!tree.length) {
        this.$message("请选择权限");
        return;
      }
      let fidArr = []; //存放父级rule id
      this.addBody.rules = [];
      this.addBody.rules_name = [];
      //如果三级的时候 没有获取到最外面的一级id
      tree.forEach(item => {
        fidArr.push(item.fid);
        this.addBody.rules.push(item.id);
        this.addBody.rules_name.push(item.menu_name);
      });
      //fidArr去重添加到权限列表 子有权限 父级肯定也有权限
      let twoId = [...new Set(fidArr)];
      //如果三级的时候 去获取到最外面的一级id
      let oneId = [];
      this.powerTree.forEach(one => {
        if (one.two && one.two.length) {
          one.two.forEach(two => {
            if (twoId.includes(two.id)) {
              oneId.push(two.fid);
            }
          });
        }
      });
      let parentId = twoId.concat([...new Set(oneId)]);
      this.addBody.rules = this.addBody.rules.concat(parentId);
      switch (this.type) {
        case "add": {
          const { status } = await addLimitsUser(this.addBody);
          if (status === 200) {
            this.$router.go(-1);
          }
          break;
        }
        case "edit": {
          const { data, status } = await SetLimitsList(this.addBody);
          if (status === 200) {
            this.$router.go(-1);
          }
          break;
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.dialog-body-wrap {
  text-align: center;
  .item-wrap {
    display: flex;
    margin-bottom: 30px;
    label {
      width: 80px;
      margin-right: 40px;
    }
    .name_input {
      width: 200px;
    }
  }
  .btn-wrap {
    margin-top: 50px;
  }
}
</style>
